import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getAssessmentSelector } from '../selectors'
import { setAddToTimeLine } from '../store/assessment.actions'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { IAssessmentState } from '../store/assessment.types'
import { addAssessment } from '../../../timeline/store/timeline.actions'
import { AssessmentConstants } from '../store/assessment.constant'
import { INemsisSnomedLookup } from '../../../../components/procedure/store/procedure.types'
import { handleNemsisCodeError } from '../../../../utilities/nemsisCode.util'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'

const processNemsisCode = (
  assessmentState: IAssessmentState,
  nemsisCodeOptions: INemsisSnomedLookup[]
): IAssessmentState => {
  try {
    const { action } = assessmentState
    const actionNemsisCode = action?.nemsisCode
    const actionSnomedId =
      nemsisCodeOptions.find(
        (option) => option.code === actionNemsisCode && option.procedure === assessmentState.action
      )?.snomedId ?? null

    return {
      ...assessmentState,
      nemsisCode: (actionNemsisCode as number) ?? null,
      snomedId: actionSnomedId,
    }
  } catch (error) {
    return handleNemsisCodeError(error, assessmentState)
  }
}

export function* saveAssessment() {
  let assessmentState: IAssessmentState = yield select(getAssessmentSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  if (!pcrID) {
    // todo: add to audit log
    return
  }
  assessmentState = processNemsisCode(assessmentState, nemsisCodeOptions)

  try {
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const assessmentList = pcrDoc.patient.assessmentsStateList || []
    const existingIndex = assessmentList.findIndex((data) => data.key === assessmentState.key)
    if (existingIndex !== -1) {
      assessmentList[existingIndex] = assessmentState
    } else {
      assessmentList.push(assessmentState)
    }
    const pcrDocUpdated = {
      ...pcrDoc,
      patient: {
        ...pcrDoc.patient,
        assessmentsStateList: assessmentList,
      },
    }

    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(addAssessment())
  } catch (e) {
    yield put(throwPcrException(`saveAssessment() error: ${e}`))
  }
}
export function* saveAssessmentSaga() {
  yield takeLatest(
    [
      AssessmentConstants.SAVE_ASSESSMENT,
      AssessmentConstants.SET_DATE,
      AssessmentConstants.SET_TIME,
      AssessmentConstants.SET_DATE_TIME,
      AssessmentConstants.SET_PTA,
      AssessmentConstants.SET_ASSESSED_BY,
      AssessmentConstants.SET_ROLE_PERFORMING,
      AssessmentConstants.SET_ROLE_PERFORMING_PNNV,
      AssessmentConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      AssessmentConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      AssessmentConstants.SET_PROCEDURE_COMPLICATIONS,
      AssessmentConstants.SET_RESPONSE,
      AssessmentConstants.SET_RESPONSE_PNNV,
      AssessmentConstants.SET_AUTHORIZATION,
      AssessmentConstants.SET_SEPSIS_INDICATORS,
    ],
    performWithMutexHOG,
    saveAssessment
  )
}
